import { render, staticRenderFns } from "./Votings.vue?vue&type=template&id=ffb7b248"
import script from "./Votings.vue?vue&type=script&lang=js"
export * from "./Votings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports